import { useState } from 'react';
import { Link } from 'react-router-dom';

type Solution = {
  id: string;
  icon: string;
  pain: string;
  solution: string;
  outcome: string;
  metric: string;
  cta: string;
  href: string;
};

const solutions: Solution[] = [
  {
    id: 'inbox',
    icon: 'inbox',
    pain: 'I spend 3 hours a day managing emails',
    solution:
      'An AI assistant that triages your inbox, drafts replies in your voice, and only surfaces what actually needs your attention.',
    outcome: 'Reclaim 10+ hours every week. Never miss a priority thread again.',
    metric: '10+ hrs / week saved',
    cta: 'Explore Email Automation',
    href: '/services#email-communication',
  },
  {
    id: 'leads',
    icon: 'person_check',
    pain: "We're losing leads because follow-up is slow",
    solution:
      'Lead automation that qualifies instantly, sends personalized outreach, and books meetings — all before your competitor finishes their coffee.',
    outcome: 'Respond to every lead in minutes, not hours. Close more, chase less.',
    metric: '3× faster response',
    cta: 'Explore Sales Automation',
    href: '/services#sales-leads',
  },
  {
    id: 'data',
    icon: 'table_view',
    pain: "Data entry is eating my team's week",
    solution:
      'Extract, compile, validate, and enter data from any source — PDFs, forms, spreadsheets — with human checkpoints where accuracy matters.',
    outcome: 'Eliminate repetitive copy-paste work. Your team focuses on analysis, not typing.',
    metric: '85% less manual entry',
    cta: 'Explore Data Processing',
    href: '/services#data-entry',
  },
  {
    id: 'crm',
    icon: 'dashboard',
    pain: 'Our CRM lists feel stuck in 2014',
    solution:
      'Check out the Bizi Marketplace for EspoCRM extensions — List View Pro and Enum Plus bring your platform into the modern era.',
    outcome: 'A CRM experience your team actually enjoys using. Built for EspoCRM, ready in minutes.',
    metric: 'Instant upgrade',
    cta: 'Browse Bizi Marketplace',
    href: '/marketplace',
  },
];

export function RealSolutions() {
  const [active, setActive] = useState(0);

  return (
    <div className="real-solutions">
      <div className="real-solutions-layout">
        <div className="real-solutions-nav">
          {solutions.map((s, i) => (
            <button
              key={s.id}
              type="button"
              className={`real-solutions-tab${i === active ? ' is-active' : ''}`}
              onClick={() => setActive(i)}
              aria-pressed={i === active}
            >
              <span className="real-solutions-tab-icon">
                <span className="material-symbols-outlined">{s.icon}</span>
              </span>
              <span className="real-solutions-tab-pain">{s.pain}</span>
              <span className="material-symbols-outlined real-solutions-tab-arrow">
                chevron_right
              </span>
            </button>
          ))}
        </div>

        <div className="real-solutions-display card">
          <div className="real-solutions-display-inner" key={solutions[active].id}>
            <div className="real-solutions-display-header">
              <div className="real-solutions-display-icon">
                <span className="material-symbols-outlined">{solutions[active].icon}</span>
              </div>
              <div className="real-solutions-display-pain">
                <span className="eyebrow">The Problem</span>
                <h3>&ldquo;{solutions[active].pain}&rdquo;</h3>
              </div>
            </div>

            <div className="real-solutions-body">
              <div className="real-solutions-solution">
                <span className="real-solutions-label">
                  <span className="material-symbols-outlined">lightbulb</span>
                  Our Solution
                </span>
                <p>{solutions[active].solution}</p>
              </div>

              <div className="real-solutions-outcome">
                <div className="real-solutions-metric">
                  <span className="real-solutions-metric-value">{solutions[active].metric}</span>
                </div>
                <p>{solutions[active].outcome}</p>
              </div>
            </div>

            <Link className="btn btn-primary real-solutions-cta" to={solutions[active].href}>
              {solutions[active].cta}
              <span className="material-symbols-outlined">arrow_forward</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
